<template>
	<AppDialog ref="dialog_container" dialogName="MappingBlockMappingDialog" closeTop="4" closeRight="4">
		<div class="dialog-container display-flex flex-column flex-align-center flex-justify-space-between">
			<div class="width-100 flex-centerize flex-column">
				<div class="title-container mb-5">Choose a {{ serviceName }} mapping block to use for this step</div>
				<InterfaceBlocksSelector
					class="pl-2 mb-3"
					:fields="mappingBlocksFields"
					v-model="selectedFieldUUID"
					:configurationId="configurationId"
				/>
			</div>
			<div class="flex-centerize flex-column">
				<div class="mb-4 display-flex flex-row footer-text">
					To create new mapping block,
					<div @click="editSetup" class="ml-1 link-text">edit setup</div>
				</div>
				<AnemicButton @click="save" class="done-button">Done</AnemicButton>
			</div>
		</div>
	</AppDialog>
</template>

<script>
import { mapActions } from 'vuex';
import AppDialog from '@/components/dialogs/AppDialog/AppDialog';
import { DRAWER_MODES } from '@/store/modules/leftSideDrawer/state';
import InterfaceBlocksSelector from '@/components/Project/InterfaceBlocksSelector/InterfaceBlocksSelector';
import { setLeftSideDrawerState } from '@/store/modules/leftSideDrawer/actions';
export default {
	name: 'MappingBlockMappingDialog',
	components: {
		AppDialog,
		InterfaceBlocksSelector,
	},
	props: {
		sourceFieldUuid: { type: String },
		configurationId: { type: Number },
		mappingBlocksFields: { type: Array, required: true },
		serviceName: { type: String },
		dialogPromiseHandlers: { type: Object },
	},
	computed: {},
	methods: {
		...mapActions([setLeftSideDrawerState.fullPath]),
		close() {
			this.$refs.dialog_container.closeCurrentDialog();
		},
		editSetup() {
			this.close();
			this[setLeftSideDrawerState.fullPath](DRAWER_MODES.test);
		},
		save() {
			this.dialogPromiseHandlers.resolve(this.selectedFieldUUID);
			this.close();
		},
	},
	data() {
		return {
			selectedFieldUUID: this.sourceFieldUuid,
		};
	},
};
</script>

<style scoped lang="scss">
.dialog-container {
	width: 640px;
	height: 700px;
	border-radius: 14px;
	background: var(--bg-color);
	padding: 32px 32px 12px 32px;
	box-shadow: 0px 3px 6px var(--shadow-color);

	.title-container {
		font-size: 16px;
		font-weight: medium;
		background: var(--bg-color);
		color: var(--primary-font-color);
	}
}

.done-button {
	width: 166px;
	height: 46px !important;
	padding: 0px !important;
	background: var(--primary-color) !important;

	font-weight: medium;
	color: var(--bg-color);
	font-size: 14px !important;
}

.footer-text {
	font-size: 14px;
	color: var(--primary-font-color);
	.link-text {
		cursor: pointer;
		text-decoration: underline;
		color: var(--primary-font-color);
	}
}
</style>
